import { createFileRoute, redirect } from '@tanstack/react-router';
import { useCurrentTask, useStore } from 'engine/store';
import { TaskScreen } from './rounds/$roundId/task/$taskId';
import { Sparkles } from 'lucide-react';
import { EmptyStateComponent } from 'components/EmptyStateComponent';
import { redirectBasedOnPlayState } from 'engine/api';

export const Route = createFileRoute('/current-task')({
	component: RouteComponent,

	beforeLoad: async () => {
		const { game } = useStore.getState();

		if (!game) {
			throw redirect({
				to: '/',
			});
		}

		redirectBasedOnPlayState(location as unknown as Location);

		if (game.automaticNavigation !== 'per-task') {
			// you should not be here
			throw redirect({
				to: '/',
			});
		}
	},
});

function RouteComponent() {
	const curTask = useCurrentTask();

	return (
		<>
			{curTask.task && (
				<TaskScreen roundId={curTask.roundId} roundTitle={curTask.roundTitle} task={curTask.task} taskState={curTask.taskState} />
			)}
			{!curTask.task && (
				<EmptyStateComponent icon={Sparkles} title="No current task" description="Wait for game master to start the next task." />
			)}
		</>
	);
}
